import axios from "axios";

function getCookie(name) {
  const part = document.cookie.split("; ").find(v => v.startsWith(name + "="));
  return part ? decodeURIComponent(part.split("=").slice(1).join("=")) : "";
}

const API_PREFIX = "/api";
const EDGE_AUTH = "";

// Mesma origem (https://auroraself.com)
export const api = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

function isAbsoluteUrl(u) {
  return /^https?:\/\//i.test(u);
}

// Normaliza URL para sempre cair em /x7a9/api/...
function normalizeApiUrl(inputUrl) {
  if (!inputUrl) return API_PREFIX;

  // Se for URL absoluta, não mexe (evita duplicação).
  // Obs: se você não quer jamais fazer request absoluta por esta instância, pode remover isso.
  if (isAbsoluteUrl(inputUrl)) return inputUrl;

  let u = String(inputUrl);

  // Garante barra inicial
  if (!u.startsWith("/")) u = "/" + u;

  // Se já estiver no prefixo novo, ok
  if (u === API_PREFIX || u.startsWith(API_PREFIX + "/")) return u;

  // Se vier /api antigo e você quiser migrar automaticamente (opcional):
  // if (u.startsWith("/api/")) return API_PREFIX + u.slice(4);
 
  // Caso contrário, prefixa
  return API_PREFIX + u;
}

api.interceptors.request.use((config) => {
  // 1) CSRF (mantém seu comportamento)
  const csrf = getCookie("csrf");
  if (csrf) {
    config.headers = config.headers || {};
    config.headers["X-CSRF-Token"] = csrf;
  }

  // 2) Normaliza URL (só para paths relativos)
  if (typeof config.url === "string" && !isAbsoluteUrl(config.url)) {
    config.url = normalizeApiUrl(config.url);
  }

  // 3) Edge header (somente quando a rota for /x7a9/api)
  // Evita mandar para endpoints não relacionados.
  if (EDGE_AUTH && typeof config.url === "string") {
    const u = config.url;
    const isProtectedPath =
      (!isAbsoluteUrl(u) && (u === API_PREFIX || u.startsWith(API_PREFIX + "/"))) ||
      (isAbsoluteUrl(u) && u.includes(API_PREFIX)); // caso raro: absoluta no mesmo host

    if (isProtectedPath) {
      config.headers = config.headers || {};
      config.headers["X-Edge-Auth"] = EDGE_AUTH;
    }
  }

  return config;
});
